// extracted by css-extract-rspack-plugin
export default {"action-button":"ActionButton_action-button__wo0-k ButtonText_button-text__qdQtd","action-button__title":"ActionButton_action-button__title__8mZnt"};